import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_navigation-done",
  "use": "svg_navigation-done-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg_navigation-done\"><path d=\"M11.02 5.364A1 1 0 0 0 9.606 3.95l1.414 1.414Zm-6.364 4.95-.707.707a1 1 0 0 0 1.414 0l-.707-.707ZM2.706 6.95a1 1 0 0 0-1.414 1.414L2.707 6.95Zm6.9-3L3.949 9.607l1.414 1.414 5.657-5.657L9.606 3.95ZM5.363 9.607 2.707 6.95 1.292 8.364l2.657 2.657 1.414-1.414Z\" fill=\"#78C99E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol